import { instance } from "libs/api";

import { StaffManagerListItem } from "../../staff.types";
import { ApiRoutesStaff } from "./../../constants";
import { updateStaffManagerPayload } from "./updateStaffManager.types";

export const requestUpdateStaffManager = async (
  body: updateStaffManagerPayload
): Promise<StaffManagerListItem> => {
  return await instance.put(ApiRoutesStaff.StaffManager, body);
};
